import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { BodyEnvioDuracion } from 'src/app/interfaces/body_envioDuracion';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { LOADING, TIEMPO_INACTIVO } from 'src/app/routes.constants';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-duracion-contrato',
  templateUrl: './duracion-contrato.component.html',
  styleUrls: ['./duracion-contrato.component.scss']
})

export class DuracionContratoComponent implements OnInit {
  // Codificar base64 btoa();
  // Decodificar base64 atob(); 

  @ViewChild('datepicker') datepicker!: ElementRef;
  public model!: NgbDateStruct;
  placement = 'Left';

  json: string = '';
  jsonFinal: string = '';
  parametro: string = '';
  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  sessionId: string = '';

  checador: any;
  saliendo: boolean = false;
  today = new Date();
  pipe = new DatePipe('en-US');
  fechaActual = this.pipe.transform(this.today, 'dd/MM/yyyy');

  fechaMin: string = '';
  fechaMax: string = '';

  desbilitar12: boolean = false;
  desbilitar6: boolean = false;

  swValidacionFechaSupera: boolean = false;
  swValidacionFechaInferior: boolean = false;
  swValidacionDuracion: boolean = false;
  swValidacionSeleccionarFecha: boolean = false;

  dataEnvio: BodyEnvioDuracion = {
    SessionId: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    screenPercentage: '',
    productFamily: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        Code: '',
        CityCode: '',
        DepartmentCode: '',
        CityProperty: '',
      },

      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  };

  response!: ResponseServices;

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }
  leadId: string = '';
  codAsesor: string = '';
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        console.log('Mouse inactivo');
        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codAsesor, idLead: this.leadId, porcPll: '15', msnPll: 'Tiempo inactivo_duración', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  formulario: FormGroup = new FormGroup(
    {
      datepicker: new FormControl('')
    });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  private obtenerFechaActual(objeto: string): string {
    let fecha = objeto.split("/");
    if (fecha !== null) {
      let año = fecha[2];
      let mes = fecha[1];
      let dia = fecha[0];
      return (año + "-" + mes + "-" + dia);
    }
    else {
      return ''
    }
  }

  private obtenerFechaActualAUnMes(objeto: string): string {
    let fecha = objeto.split("/");
    if (fecha !== null) {
      let año = fecha[2];
      let mes = fecha[1];
      let dia = fecha[0];

      if ((mes === "1") || (mes === "3") || (mes === "5") ||
        (mes === "7") || (mes === "8") || (mes === "10") || (mes === "12")) {
        return (año + "-" + ((Number(mes) + 1) < 10 ? ("0" + (Number(mes) + 1)) : (Number(mes) + 1)) + "-" + dia);
      }
      else {
        return (año + "-" + ((Number(mes) + 1) < 10 ? ("0" + (Number(mes) + 1)) : (Number(mes) + 1)) + "-" + (Number(dia) - 1));
      }
    }
    else {
      return ''
    }
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;
  @Input() codigoAsesor?: string = '';
  @Input() bitacoraId: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.sessionId = this.getLocalStorage().toString();
    this.fechaMin = this.obtenerFechaActual(this.fechaActual === null ? '' : this.fechaActual);
    this.fechaMax = this.obtenerFechaActualAUnMes(this.fechaActual === null ? '' : this.fechaActual);

    this.saliendo = false;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        console.log('Datos generales actualizados - Timestamp:', Date.now());
        this.parametro = JSON.stringify(this.datosGenerales);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';
        this.codAsesor = this.codigoAsesor !== undefined ? this.codigoAsesor : '';
        this.IdBitacora = this.bitacoraId !== undefined ? this.bitacoraId : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);

          this.formulario.get("datepicker")?.setValue(this.convertirFecha(this.datosGenerales.InfoArrendamiento.fechaContrato));
        }
      }
    });
  }


  ngOnDestroy(): void {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.checador) {
      clearInterval(this.checador);
    }
  }

  get fechaNoValida() {
    if (this.formulario.get("datepicker")?.value === undefined
      && this.formulario.get("datepicker")?.touched) {
      return true;
    }
    return false;
  }

  duracionContrato(duracion: number) {
    if (duracion === 6) {
      if (this.desbilitar6 && !this.desbilitar12) {
        this.desbilitar6 = false;
      }
      else {
        this.desbilitar6 = true;
        this.swValidacionDuracion = false;
      }
    }
    else {
      this.desbilitar6 = false;
    }

    if (duracion === 12) {
      if (!this.desbilitar6 && this.desbilitar12) {
        this.desbilitar12 = false;
      }
      else {
        this.desbilitar12 = true;
      }
    }
    else {
      this.desbilitar12 = false;
      this.swValidacionDuracion = false;
    }

    this.datosGenerales.InfoArrendamiento.duracionContrato = duracion == undefined ? '12' : duracion.toString();
  }

  convertirFecha(fecha: string): string {
    const [year, month, day] = fecha.split('-');
    const nuevaFecha = `${day}/${month}/${year}`;
    return nuevaFecha;
  }

  private convertirObjectFechaToString(objeto: AbstractControl): string {
    let fecha = objeto.value.toString().split("-");
    if (fecha !== null) {
      let año = fecha[0];
      let mes = fecha[1];
      let dia = fecha[2];
      return (dia + "/" + mes + "/" + año);
    }
    else {
      return ''
    }
  }

  private convertirObjectFechaToStringV2(objeto: string): string {
    let fecha = objeto.toString().split("-");
    if (fecha !== null) {
      let año = fecha[0];
      let mes = fecha[1];
      let dia = fecha[2];
      return (dia + "/" + mes + "/" + año);
    }
    else {
      return ''
    }
  }

  ValidarFechaContrato() {
    if (this.formulario.get("datepicker")?.value !== undefined) {
      const fechaContrato = this.convertirObjectFechaToString(this.formulario.get("datepicker")!);
      var seleccionada = moment(fechaContrato, "DD/MM/YYYY");
      var fechaMax = this.convertirObjectFechaToStringV2(this.fechaMax);
      var fechaMin = this.convertirObjectFechaToStringV2(this.fechaMin);
      var fechaFinal = moment(fechaMax, "DD/MM/YYYY");
      var fechaFinalMin = moment(fechaMin, "DD/MM/YYYY");

      if (seleccionada.isAfter(fechaFinal)) {
        this.swValidacionFechaSupera = true;
        this.formulario.get("datepicker")?.setValue('');
        return;
      }
      else {
        this.swValidacionFechaSupera = false;
      }

      if (seleccionada.isBefore(fechaFinalMin)) {
        this.swValidacionFechaInferior = true;
        this.formulario.get("datepicker")?.setValue('');
        return;
      }
      else {
        this.swValidacionFechaInferior = false;
      }
    }
  }

  PlanesSeguros() {
    if (this.datosGenerales.InfoArrendamiento.duracionContrato === undefined ||
      this.datosGenerales.InfoArrendamiento.duracionContrato === '') {
      this.swValidacionDuracion = true;
      return;
    }
    else {
      this.swValidacionDuracion = false;
    }

    if (this.formulario.get("datepicker")?.value === undefined) {
      this.swValidacionSeleccionarFecha = true;
      this.datepicker.nativeElement.focus();
      return;
    }
    else {
      this.swValidacionSeleccionarFecha = false;
    }

    let fechaSeleccionada = this.convertirFecha(this.formulario.get("datepicker")?.value);
    this.datosGenerales.InfoArrendamiento.fechaContrato = fechaSeleccionada;
    this.parametro = JSON.stringify(this.datosGenerales);


    this._dataLayerService.logDuracion('ecommerce_step_3', 'Arrendamiento', 'Duracion contrato',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato);

    this.GuardarDataLayer();

    this.router.navigate([LOADING, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  private GuardarDataLayer() {
    this.dataEnvio.SessionId = this.sessionId;
    this.dataEnvio.productFamily = "Arrendamientos";
    this.dataEnvio.leadId = this.leadId;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.dataEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    this.dataEnvio.bitacoraId = this.IdBitacora;
    this.dataEnvio.screenPercentage = "15";
    this.dataEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
    this.dataEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.dataEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.dataEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.dataEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.dataEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.dataEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.dataEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.dataEnvio.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.dataEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.dataEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.dataEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.dataEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


    console.log('Datos de envío preparados - Timestamp:', Date.now());
    this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvio).
      subscribe(
        (data) => {
          this.response = data;
        }
      );
  }
}
